<div class="topbar">
  <span class="title-text">{{ displayTitle() }}</span>
</div>

<div class="chat-exchange-container">
  <chat-exchange [chatId]="chatId()" [messages]="messageList()" />
</div>
<div class="chat-prompt-container">
  <chat-prompt
    placeholder="Ask a follow-up..."
    (submit)="sendMessage($event)"
    [(text)]="userInput"
  />
</div>
